import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

const publicUrl = process.env.PUBLIC_URL || '';
const logoSources = [
  `${publicUrl}/assets/biofleet-logo.png?v=20260630`,
  '/assets/biofleet-logo.png?v=20260630',
  `${publicUrl}/logo192.png`,
  '/logo192.png',
].filter(Boolean);

export default function BrandLogo({
  height = 42,
  compact = false,
  showText = true,
  textColor = '#001f3f',
  subtitleColor = 'rgba(0,31,63,0.62)',
  logoPlate = false,
  logoGlow = false,
  sx = {},
}) {
  const [sourceIndex, setSourceIndex] = useState(0);
  const failed = sourceIndex >= logoSources.length;
  const logoWidth = compact ? height * 1.45 : height;
  const logoNode = !failed ? (
    <Box
      component="img"
      src={logoSources[sourceIndex]}
      alt="BioFleet"
      onError={() => setSourceIndex((index) => index + 1)}
      sx={{
        height,
        width: logoWidth,
        objectFit: 'contain',
        flexShrink: 0,
        display: 'block',
        filter: logoGlow
          ? 'drop-shadow(0 0 1px rgba(255,255,255,0.95)) drop-shadow(0 0 3px rgba(255,255,255,0.82)) drop-shadow(0 5px 12px rgba(0,0,0,0.32))'
          : 'none',
      }}
    />
  ) : (
    <Box
      sx={{
        width: height,
        height,
        borderRadius: 2,
        bgcolor: '#001f3f',
        color: '#d7ef23',
        display: 'grid',
        placeItems: 'center',
        fontWeight: 950,
        letterSpacing: -1,
        flexShrink: 0,
      }}
    >
      B
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: compact ? 0 : 1.25, minWidth: 0, ...sx }}>
      {logoPlate ? (
        <Box
          sx={{
            bgcolor: '#ffffff',
            borderRadius: 2,
            p: 0.45,
            boxShadow: '0 6px 16px rgba(0,0,0,0.22)',
            flexShrink: 0,
          }}
        >
          {logoNode}
        </Box>
      ) : (
        <Box sx={{ animation: logoGlow ? 'biofleetFloat 4.5s ease-in-out infinite' : 'none', flexShrink: 0 }}>
          {logoNode}
        </Box>
      )}
      {showText && !compact && (
        <Box sx={{ minWidth: 0, lineHeight: 1 }}>
          <Typography sx={{ fontWeight: 950, color: textColor, fontSize: 14, lineHeight: 1 }}>
            BioFleet
          </Typography>
          <Typography sx={{ color: subtitleColor, fontWeight: 800, fontSize: 11, mt: 0.25 }}>
            Biomed Recovery & Disposal ltd.
          </Typography>
        </Box>
      )}
    </Box>
  );
}
